const config = {
	env: "local",
	// apiUrl: "https://d4m5hgzh-8500.inc1.devtunnels.ms/admin",
	// apiUrl: "http://localhost:8509/admin",
	apiUrl: "https://api.totalqualitypl.com/admin",
};



export default config;
